<template>
  <div>
    <el-dialog
      :title="$t('mdfeTranslate.ExportNFSeInvoice')"
      :visible.sync="showExportNFSeInvoice"
      width="700px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
      @close="onClose"
    >
      <div>
        <el-form
          ref="ruleForm"
          size="small"
          label-position="top"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('orderCenterCont.DownloadTemplate')">
                <div ref="download1">
                  <span style="cursor: pointer" @click="initDown()">
                    <span style="color:#00A551;">导出NFSe模板(Modelo de Exportação NFSe).xlsx</span>
                    <span class="el-icon-download" style="color:#00A551;margin-left: 20px" />
                  </span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$t('basicData.UploadTheFile')"
              >
                <el-upload
                  ref="demoUpload"
                  :before-upload="beforeUpload"
                  :file-list="fileList"
                  :http-request="upLoad"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :on-remove="handleRemove"
                  action
                  class="upload-demo"
                  drag
                  multiple
                >
                  <i class="el-icon-plus" style="margin: 50px auto 20px;" />
                  <!-- 点击或拖拽文件到此处上传 -->
                  <div class="el-upload__text">{{ $t('orderImport.cldrUpload') }}</div>
                  <!--请上传.txt格式文件-->
                  <div class="el-upload__text">{{ $t('collectionCenter.uploadOnlyXlsx') }}</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--业务类型-->
              <div style="font-weight: bold; margin-top: 10px;">{{ $t('collectionCenter.businessT') }}</div>
              <div>
                <el-select v-model="businessType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                  <el-option key="0" :label="$t('collectionCenter.expressDelivery')" :value="0" /><!--快递-->
                  <el-option key="1" :label="$t('collectionCenter.collect')" :value="1" /><!--揽收-->
                </el-select>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showExportNFSeInvoice = false">{{ $t('collectionCenter.close') }}</el-button>
        <el-button size="small" type="primary" @click="submitForm">{{ $t('collectionCenter.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { goResourceTaskList } from '@/utils/goExportList.js';
import {
  exportNFSeInvoiceApi
} from '@/api/invoiceCenter';
export default {
  data() {
    return {
      fileList: [],
      upLoadFile: {},
      businessType: null,
      isUpload: false,
      showExportNFSeInvoice: false
    };
  },
  methods: {
    // 打开弹窗
    openExportNFSeInvoice() {
      this.showExportNFSeInvoice = true;
    },
    // 关闭弹窗
    onClose() {
      this.handleRemove();
      this.showExportNFSeInvoice = false;
    },
    initDown() {
      const a = document.createElement('a');
      a.href = '/static/NFSe导出模板(Modelo de Exportação NFSe).xlsx';
      a.download = 'NFSe导出模板(Modelo de Exportação NFSe)';
      a.style.display = 'none';
      this.$nextTick(() => {
        this.$refs.download1.appendChild(a);
      });
      a.click();
      a.remove();
    },
    beforeUpload(file) {
      const whiteList = ['xls', 'xlsx'];
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (whiteList.indexOf(fileSuffix) === -1) {
        // 上传文件只能是xlsx格式
        this.$message.error(this.$t('collectionCenter.uploadOnlyXlsx'));
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        // 上传文件大小不能超过 2MB
        this.$message.error(this.$t('collectionCenter.uploadNot10MB'));
        return false;
      }
    },
    upLoad(option) {
      // 导入xlsx模版
      const files = option.file;
      this.isUpload = true;
      this.upLoadFile = new FormData();
      this.upLoadFile.append('file', files);
      this.fileList = [files];
    },
    handleRemove() {
      this.fileList = [];
      this.upLoadFile = {};
      this.isUpload = false;
    },
    handleExceed() {
      this.$message.error(this.$t('basicData.Only1FileCanBeUploadedAtATime'));
    },
    submitForm() {
      if (this.isUpload) {
        if (this.businessType === null || this.businessType === '' || this.businessType === undefined) {
          this.$message.warning(this.$t('mdfeTranslate.PleaseSelectBusinessType'));
          return;
        }
        this.upLoadFile.append('businessType', this.businessType);
        exportNFSeInvoiceApi(this.upLoadFile).then(() => {
          this.onClose();
          goResourceTaskList();
        }).catch(err => {
          console.error(err);
        });
      } else {
        this.$message.warning(this.$t('routes.pleaseUploadFile'));
      }
    }
  }
};
</script>

<style scoped>

</style>
